<p>
  A integração por API funcionará com suas credenciais de acesso ao portal. Clique no botão abaixo para baixar o manual.
</p>
  <hr>
  <a [href]="UrlDocumentacao|safe:'resourceUrl'" target="_blank" class="btn btn-lg btn-info"><i class="fas fa-book"></i> Manual de Integração de API</a>
